import {
  ListItemIcon,
  MenuItem, MenuList, Typography,
} from '@mui/material';
import { RefObject } from 'react';
import { style } from './style';

type Items = {
  icon: JSX.Element;
  title: string,
  type: string,
  color: string,
  ref?: RefObject<HTMLLIElement>,
}

type BulkEditItemProps = {
  items: Items[],
  onActionClick: (type: string) => void,
}

export const MatchesBulkPanelItems = ({
  items,
  onActionClick,
}: BulkEditItemProps):JSX.Element => {
  return (
    <MenuList style={ style.MenuList.flex }
      sx={ style.MenuList.sx }
    >
      {items.map((item) => {
        return (
          <MenuItem
            key={ item.title }
            ref={ item.ref }
            onClick={ () => onActionClick(item.type) }
          >
            <ListItemIcon sx={ style.icon.sx(item.color) }>
              {item.icon}
            </ListItemIcon>
            <Typography variant="overline" color={ item.color }>
              {item.title}
            </Typography>
          </MenuItem>
        );
      })}
    </MenuList>
  );
};
